<template>
  <!-- <SignUpProgress/> -->
  <b-container>
    <b-row>
      <b-col sm="12" lg="6">
        <div class="parent">
          <div>
            <div class="portal-lp">
              <h1 class="mt-0" v-html="headline"/>
              <p style="font-size: 1.15em; margin-bottom: 1.3em;" v-html="subtitle"/>
              <ul class="list-3">
                <li class="container-3">
                  <div class="item-container-3">
                    <div class="item-wrapper">
                      <div class="middle">
                        <img
                          src="/static/images/homepage/quality.svg"
                          alt="icon"
                        />
                        <p class="list-copy">All-in-one business card solution</p>
                      </div>
                    </div>
                  </div>
                </li>

                <li class="container-3">
                  <div class="item-container-3">
                    <div class="item-wrapper">
                      <div class="middle">
                        <img
                          src="/static/images/homepage/quality.svg"
                          alt="icon"
                        />
                        <p class="list-copy">1-minute setup</p>
                      </div>
                    </div>
                  </div>
                </li>

                <li class="container-3">
                  <div class="item-container-3">
                    <div class="item-wrapper">
                      <div class="middle">
                        <img
                          src="/static/images/homepage/quality.svg"
                          alt="icon"
                        />
                        <p class="list-copy">Free shipping, always</p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div style="height: 1.8em;"/>

          <div class="icon-wrapper">
            <img
              src="/static/images/landingpages/kettlebell_logo.svg"
              alt="icon"
            />
            <img
              src="/static/images/landingpages/shipworks_logo.svg"
              alt="icon"
            />
            <img
              src="/static/images/landingpages/stockwell_logo.svg"
              alt="icon"
            />
            <img src="/static/images/landingpages/medly_logo.svg" alt="icon" />
          </div>
        </div>
      </b-col>

      <b-col sm="12" lg="6">
        <div class="parent" id="scroll-to-signup">
          <div class="box-shape">
            <div class="signup-header">
              <h1 style="margin-top: 10px;">See Brandly in action.</h1>
              <h2>NO CREDIT CARD REQUIRED</h2>
            </div>
            <div class="wrapper">
              <SignUpForm>Open free portal now</SignUpForm>
            </div>
            <div class="wrapper" id="social">
              <h2>OR SIGNUP USING</h2>
              <div>
                <GoogleCircle @login="onGoogleLogin"></GoogleCircle>
                <LinkedInCircle @login="onLinkedInLogin"></LinkedInCircle>
              </div>
            </div>
            <div class="questions">
              <p>
                Questions?
                <a href="https://www.brandly.com/contact" target="_blank" @click="openIntercom"
                  >&nbsp; Chat with us now
                  <img src="/static/images/landingpages/chat.svg" alt="icon"
                /></a>
              </p>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    headline: {type: String, default: 'Headline goes here'},
    subtitle: {type: String, default: 'Subtitle goes here.'},
  },
  computed: {
    ...mapGetters(["loginError"]),
    hasIntercom() {
      console.log('hasIntercom', window.Intercom);
      return !!window.Intercom;
    }
  },
  methods: {
    ...mapActions(["socialAuth"]),
    async onGoogleLogin(userinfo) {
      console.log("google user:", userinfo);
      await this.socialAuth({
        provider: "google",
        access_token: userinfo.auth.access_token
      });
      this.redirect();
    },
    async onFacebookLogin() {
      // not implemented
    },
    async onLinkedInLogin(info) {
      console.log("linkedin info:", info);
      await this.socialAuth(info);
      this.redirect();
    },
    redirect() {
      if (!this.loginError) this.$router.push("/dashboard");
    },
    openIntercom(event) {
      if (window.Intercom) {
        event.preventDefault();
        Intercom("showNewMessage", "");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/colors";

.container {
  max-width: 1140px;
  padding: 1em 0;
  margin: 0 auto;
}

.parent {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 1em;
  margin: 1em;
  @media (max-width: 992px) {
    width: 500px;
    margin: 0 auto;
  }
  @media (max-width: 576px) {
    width: 100%;
    padding: 1em 0;
    margin: 0 auto;
  }
}

/* Landing page text */

.portal-lp {
  text-align: left;
  margin: 0 auto;

  h1 {
    font-size: 3rem;
    @media (max-width: 576px) {
      // font-size: 2rem;
      max-width: 330px;
      margin: 1em auto;
    }
  }
  span {
    color: $red;
  }

  p {
    font-weight: normal !important;
    color: $black-1;
    font-size: 1.2rem;
    @media (max-width: 576px) {
      max-width: 330px;
      line-height: 1.5;
      margin: 1em auto;
    }
  }
}

/* logo block */


.icon-wrapper {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding:1.3em 0;
  opacity: 0.5;

  & img {
    max-width: 6rem;
    padding: 0;
  }

  @media screen and (max-width: 670px) {
    flex-wrap: wrap;

    &::after {
      content: "";
      width: 8rem;
    }
  }

  @media screen and (max-width: 576px) {
    width: 330px;
    padding:1em 0;
    margin: 0 auto;

    & img {
    max-width: 8rem;
    padding: 0;
  }

  }
}

// .customer-logos {
//   display: flex;
//   margin-top: 1.5em;
//   & img {
//     width: 25%;
//     padding: 10px;
//   }
// }


/* Sign up form */

.signup-header,
#social {
  text-align: center;
  margin: 0 auto;

  h1 {
    font-size: 1.5rem;
  }

  h2 {
    color: $gray-1;
    text-transform: uppercase;
    font-weight: normal !important;
    font-size: 0.8rem;
    letter-spacing: 0.1rem;
    margin: 0;
    padding-bottom: 1em;
  }
}

.box-shape {
  background: #fff;
}

.wrapper {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 330px;
  // background:red;
  margin: 0 auto;
}

#social {
  width: 300px;

  > div {
    display: flex;
    justify-content: space-around;

    width: 100px;
    margin: 0 auto;
  }
}

.sign-in-btn {
  width: 100%;
  color: $gray-1;
  line-height: 20px;
  border-color: $gray-1;
}

.form-wrapper {
  margin: 0 auto;
}

.questions {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: $gray-0;
  margin: 2em auto 0 auto;
  & a {
    font-weight: normal;
    color: $gray-0;
  }
  img {
    height: 1.5em;
  }
}

p {
  margin-top: 1em;
  margin-bottom: 0;
}

/* list 3 */

.container-3 {
  list-style: none;
}

.item-container-3 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 0;
  background: #fff;
  width: 100%;
     @media (max-width: 576px) {
    max-width: 330px;
      margin: 0 auto;
  }
}

.item-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.middle > * {
  vertical-align: middle;
  }


p.list-copy {
  display: inline;
  font-size: 16px;
  color: $black-1;
}

.item-container-3 img {
  height: 20px;
  margin: 0 10px 0 0;
}

.quote {
  width: 400px;
  margin: 0 auto;
}

/* small device */

@media (max-width: 480px) {
  #social {
    padding: 0;
  }
  .has-account {
    font-size: 14px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homepage/shared/LandingPageHero.vue